import { render, staticRenderFns } from "./copys.vue?vue&type=template&id=087ed4b4&scoped=true&"
import script from "./copys.vue?vue&type=script&lang=js&"
export * from "./copys.vue?vue&type=script&lang=js&"
import style0 from "./copys.vue?vue&type=style&index=0&id=087ed4b4&lang=less&scoped=true&"
import style1 from "./copys.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ed4b4",
  null
  
)

export default component.exports